//船运单
import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 状态
 */
class State extends UltMeta {
    TO_BE_LOADED = new Meta(1, "定金确认中");
    AWAITING_DEPARTURE = new Meta(2, "待发航");
    DURING_TRANSPORTATION = new Meta(3, "运输中");
    DISCHARGED = new Meta(4, "待卸货");
    CANCELED = new Meta(5, "已取消");
    COMPlETE = new Meta(6, "已完成");
}

export const STATE = new State();

/**
 * 类型
 */
class Source extends UltMeta {
    // SELF_CREATE = new Meta(1, "自建录入");
    ZHI_HAO_LIAN_YUN = new Meta(2, "志豪链云");
    OFFLINE = new Meta(3, "线下单据");
}
export const SOURCE = new Source();

/**
 * 支付类型
 */
class DepositPayType extends UltMeta {
    PAY_ONESELF = new Meta(1, "自行支付");
    // 黄码港
    PAY_ZH = new Meta(2, "服务商垫付");
    // （签好运）
    PAY_EASY_SIGN = new Meta(3, "服务商垫付");
}

export const DEPOSIT_PAY_TYPE = new DepositPayType();

/**
 * 海事费用
 */
class MaritimeAffairsFee extends UltMeta {
    SHIPPERS_BEAR_UPSTREAM = new Meta(1, "货主承担上游");
    SHIPPERS_BEAR_DOWNSTREAM = new Meta(2, "货主承担下游");
    SHIPPERS_BEAR_BOTH_PORTS = new Meta(3, "货主承担两港");
    SHIPPERS_NOT_RESPONSIBLE = new Meta(4, "货主不承担");
}

export const MARITIME_AFFAIRS_FEE = new MaritimeAffairsFee();

/**
 * 志豪链云对接 -- 支付类型 定金和运费只有自行支付才有用
 */
class OwnerShippingDepositType extends UltMeta {
    DEPOSIT_ONE = new Meta(1, "定金1", 10);
    DEPOSIT_TWO = new Meta(2, "定金2", 12);
    DEPOSIT_THREE = new Meta(3, "定金3", 14);
    BALANCE_PAYMENT = new Meta(4, "尾款", 30);
    DEPARTURE_FEE = new Meta(5, "启航费", 20);
    DEMURRAGE = new Meta(6, "滞期费", 40);
    DEPOSIT = new Meta(7, "定金", 88);
    FREIGHT = new Meta(8, "运费", 99);
}

export const OWNER_SHIPPING_DEPOSIT_TYPE = new OwnerShippingDepositType();

class CreateBy extends UltMeta {
    SUPPLY_CHAIN = new Meta(0, "供应链");
    CUSTOM = new Meta(1, "客户端");
}
export const CREATE_BY = new CreateBy();

/**
 * 支付状态 1待对账 2待支付 3已支付 4支付失败
 */

class PayStatus extends UltMeta {
    PENDING = new Meta(1, "待对账");
    PENDING_PAYMENT = new Meta(2, "待支付");
    PAID = new Meta(3, "已支付");
    PAYMENT_FAILD = new Meta(4, "支付失败");
}
export const PAY_STATUS = new PayStatus();
